import React from "react";
import TableHeader from "../Common/TableHeader";

function SchoolActivations({schoolDashboardActivations}) {

    return (
        <div className="col-6-xxxl col-lg-6 col-12">
          <div className="card custom-card" style={{ borderRadius: "10px" }}>
            <div className="card-body map-card">
                <div class="heading-layout1 mg-b-25">
                    <TableHeader
                        title="Recent Activations"
                        subtitle="List of the recent school activations"
                    />
                    
                </div>

                <div className="border-top mt-3"></div>
                <div className="table-responsive">
                    <table className="table table-hover text-nowrap mg-b-0">
                        <thead>
                            <tr>
                            <th>Activation Date</th>
                            <th>Student Name</th>
                            <th>Activated By</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Array.isArray(schoolDashboardActivations) &&
                            schoolDashboardActivations.map((item, key) => (
                                <tr key={key}>
                                <td>{item.created_at?.short_date}</td>
                                <td>{item.last_name} {item.first_name}</td>
                                <td>{item.activated_by? item.activated_by?.full_name :"N/A"}</td>
                                </tr>
                            ))}
                      
                            {schoolDashboardActivations === "404" && (
                            <tr>
                                <td colSpan="3" style={{ textAlign: "center" }}>
                                No recent account activations.
                                </td>
                            </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
          </div>
        </div>
        
    );
}

export default SchoolActivations;
